export class Broker {
  name: string;
  primaryPhoneExtension: string;

  constructor() {
    this.name = "";
    this.primaryPhoneExtension = "";
  }
}